import {FC, useState, useEffect, useMemo} from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'
import {Card, Row, Col, Button, Image} from 'react-bootstrap'
import {deleteEconomy, getAllEconomies} from './core/_requests'
import useAxiosPrivate from '../../../libs/useAxiosPrivate'
import {Economy} from './core/_models'
import {Link} from 'react-router-dom'
import {useAbility} from '@casl/react'
import {AbilityContext} from '../../../modules/auth/core/AbilityContext'
import {EconomiesTable} from './components/EconomiesTable'
import {showSwal} from '../../../../ui-kit'

const confirmDialog = (title: string) => {
  return showSwal({
    title,
    icon: 'question',
    showCloseButton: true,
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No',
  })
}

const EconomiesPage: FC<{subject: string}> = ({subject}) => {
  const ability = useAbility(AbilityContext)
  const axiosPrivate = useAxiosPrivate()
  const [isLoading, setIsLoading] = useState(false)
  const [tableData, setTableData] = useState<Economy[]>([])

  const handleDelete = (iso3: string) => {
    confirmDialog('Are you sure you want to delete this economy?').then((result) => {
      if (!result.isConfirmed) return

      deleteEconomy(axiosPrivate, iso3).then((res) => {
        if (res.status === 200) {
          showSwal({
            title: 'Economy deleted',
            icon: 'success',
            confirmButtonText: 'OK',
          }).then(() => {
            setTableData((prev) => prev?.filter((item) => item.iso3 !== iso3))
          })
        }
      })
    })
  }



  const fetchEconomies = () => {
    setIsLoading(true)
    getAllEconomies(axiosPrivate)
      .then((res) => {
        if (res && res.data.data) {
          setTableData(res.data.data)
        }
      })
      .catch((e) => {
        console.error(e)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  useEffect(() => {
    fetchEconomies()
  }, [])

  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Home', path: '/', isSeparator: false, isActive: false},
          {title: '', path: '', isSeparator: true, isActive: false},
        ]}
      >
        Economies
      </PageTitle>
      <>
        <Row className='mb-5'>
          <Col>
            <Card className='card-custom card-border'>
              <Card.Body className='d-flex align-items-center'>
                <Image src='/media/tina/img-result-documents.jpg' thumbnail width={110} />
                <div className='ms-5 d-flex flex-column justify-content-center'>
                  <h3 className='text-primary'>Economies</h3>
                  <div className='text-gray-700'>
                    Manage economies. You can view, add, update, or delete economies.
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className='mb-5'>
          <Col>
            <Card>
              <Card.Header className='card-header-stretch'>
                <Card.Title className='w-100'>
                  <div className='title-container w-100 d-flex justify-content-between align-items-center'>
                    <div className='title d-flex align-items-center'>
                      <span className='fa fa-globe px-2'></span>
                      <h3 className='text-gray-700'>List Economies</h3>
                    </div>
                    <div className='d-flex gap-2'>
                      {ability.can('create', subject) ? (
                        <Link
                          to={'/economies/add'}
                          className='btn btn-primary d-flex gap-4 align-items-center'
                        >
                          <span className='fa fa-plus'></span>
                          Add
                        </Link>
                      ) : null}
                    </div>
                  </div>
                </Card.Title>
              </Card.Header>
              <Card.Body>
                <EconomiesTable
                  rows={tableData}
                  isLoading={isLoading}
                  onDelete={handleDelete}
                  subject={subject}
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </>
    </>
  )
}

export default EconomiesPage
